import React from "react";
import ThemeToggle from "./ThemeToggle";

const Footer = () => {
  return (
    <footer className="footer-total">
      <div className="footer-sect1">
        {/* Company Information */}
        <div className="footer-info">
          <p className="mt-2">PixeLore is a community-crafted Wiki made for Players by the Players.</p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <div className="mt-1 space-x-2 md:space-x-4">
            <a href="/about" className="footer-link">
              About Me
            </a>
            <a href="https://www.reddit.com/r/PixelsGame/" target="_blank" rel="noreferrer" className="footer-link">
              Pixels Reddit
            </a>
            <a href="https://discord.gg/pixels" target="_blank" rel="noreferrer" className="footer-link">
              Pixels Discord
            </a>
            <a href="https://twitter.com/messages/compose?recipient_id=1824947304706588672" className="footer-link">
              Contact Me
            </a>
          </div>
        </div>
        <ThemeToggle />
      </div>
    </footer>
  );
};

export default Footer;
